import { render, staticRenderFns } from "./BtnGoApply.vue?vue&type=template&id=5d6419be&"
import script from "./BtnGoApply.vue?vue&type=script&lang=js&"
export * from "./BtnGoApply.vue?vue&type=script&lang=js&"
import style0 from "./BtnGoApply.vue?vue&type=style&index=0&id=5d6419be&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports